import { orderStatusInformationStyles as orderInfoStyles } from "@iewcasia/Components/OrderInformation";
import { AddressInfoDisplayStyles } from "@iewcasia/Overrides/Components/AddressInfoDisplay";
import { informationStyles as invoiceStyles } from "@iewcasia/Overrides/Widgets/InvoiceDetails/InvoiceDetailsInformation";
import { rfqQuoteDetailsInformationStyles as rfqStyles } from "@iewcasia/Overrides/Widgets/RfqQuoteDetails/RfqQuoteDetailsInformation";
import { SmallHeadingAndTextStyles } from "@insite/content-library/Components/SmallHeadingAndText";
import { billingAddressStyles as orderBillingStyles } from "@insite/content-library/Widgets/OrderDetails/OrderDetailsBillingAddress";
import { requestedDateStyles as orderReqDateStyles } from "@insite/content-library/Widgets/OrderDetails/OrderDetailsRequestedDate";
import { shippingAddressStyles as orderShippingStyles } from "@insite/content-library/Widgets/OrderDetails/OrderDetailsShippingAddress";
import { shippingMethodStyles } from "@insite/content-library/Widgets/OrderDetails/OrderDetailsShippingMethod";
import { TypographyProps } from "@insite/mobius/Typography";
import { css } from "styled-components";

const reusableSmallHeading = (styles?: SmallHeadingAndTextStyles): SmallHeadingAndTextStyles => ({
    ...styles,
    wrapper: {
        ...styles?.wrapper,
        css: css`
            ${styles?.wrapper?.css}
            align-items: center;
            flex-direction: row;
            margin-bottom: 5px;
        `,
    },
    heading: {
        ...styles?.heading,
        variant: "p",
        forwardAs: "span",
        weight: 700,
        css: css`
            ${styles?.heading?.css}
            margin-bottom: 0;
            margin-right: 5px;
        `,
    },
    text: {
        ...styles?.text,
        variant: "p",
        forwardAs: "span",
        css: css`
            ${styles?.text?.css}
            width: auto;
            margin-bottom: 0;
        `,
    },
});

const reusableHeaderText = (styles?: TypographyProps): TypographyProps => ({
    ...styles,
    variant: "h5",
    as: "h2",
    css: css`
        @media print {
            font-size: 12px;
        }

        margin-bottom: 5px;
    `,
});

const reusableTitleText = (styles?: TypographyProps): TypographyProps => ({
    ...styles,
    variant: "h6",
    as: "h3",
    css: css`
        @media print {
            font-size: 12px;
        }

        margin-bottom: 5px;
    `,
});

const reusableAddressDisplay = (styles?: AddressInfoDisplayStyles): AddressInfoDisplayStyles => ({});

/* Invoice Styles */
invoiceStyles.headingAndTextStyles = reusableSmallHeading(invoiceStyles.headingAndTextStyles);

invoiceStyles.billingAddressStyle = {
    ...invoiceStyles.billingAddressStyle,
    headerText: reusableHeaderText(invoiceStyles.billingAddressStyle?.headerText),
    titleText: reusableTitleText(invoiceStyles.billingAddressStyle?.titleText),
    addressDisplay: reusableAddressDisplay(invoiceStyles.billingAddressStyle?.addressDisplay),
};

invoiceStyles.shippingAddressStyle = {
    ...invoiceStyles.shippingAddressStyle,
    headerText: reusableHeaderText(invoiceStyles.shippingAddressStyle?.headerText),
    titleText: reusableTitleText(invoiceStyles.shippingAddressStyle?.titleText),
    addressDisplay: reusableAddressDisplay(invoiceStyles.shippingAddressStyle?.addressDisplay),
};

/* Order & Order Status Styles */
orderInfoStyles.headingAndTextStyles = reusableSmallHeading(orderInfoStyles.headingAndTextStyles);

orderShippingStyles.titleText = reusableHeaderText(orderShippingStyles.titleText);

orderShippingStyles.addressDisplay = reusableAddressDisplay(orderShippingStyles?.addressDisplay);

shippingMethodStyles.titleText = reusableHeaderText(shippingMethodStyles.titleText);

orderReqDateStyles.titleText = reusableHeaderText(orderReqDateStyles.titleText);

orderBillingStyles.titleText = reusableHeaderText(orderBillingStyles.titleText);

orderBillingStyles.addressDisplay = reusableAddressDisplay(orderBillingStyles?.addressDisplay);

/* Quote Styles */
rfqStyles.headingAndTextStyles = reusableSmallHeading(rfqStyles.headingAndTextStyles);
